import React, { useState, useEffect } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import Pagination from 'react-bootstrap/Pagination'
import Table from 'react-bootstrap/Table'
import Modal from 'react-bootstrap/Modal'
import LoadDataset from './LoadDataset'
import AccountSettings from './AccountSettings'
import NlpViewer from './NlpViewer'
import ViewerTranscription from './ViewerTranscription'
import ViewerTranscription2 from './ViewerTranscription2'
import ViewerTranscription3 from './ViewerTranscription3'
import ViewerBBox from './ViewerBBox'
import NlpSetup from './NlpSetup'
import Config from './Config'
import NlpWorkers from './NlpWorkers'
import NlpJobs from './NlpJobs'
import NlpProjectBrowse from './NlpProjectBrowse'
import DatasetBrowse from './DatasetBrowse'
import DatasetSetup from './DatasetSetup'
import DatasetItems from './DatasetItems'
import DatasetAdvanced from './DatasetAdvanced'
import DatasetWorkers from './DatasetWorkers'
import DatasetExports from './DatasetExports'
import DatasetModelRuns from './DatasetModelRuns'
import ProjectExports from './ProjectExports'
import DatasetUpload from './DatasetUpload'
import DatasetRecipes from './DatasetRecipes'
import DatasetChatBot from "./DatasetChatBot"
// import DatasetRecipeView from './DatasetRecipeView'
import NlpBrowse from './NlpBrowse'
import Test from './Test'
import Users from './Users'
import UserSetup from './UserSetup'
import UserRole from './UserRole'
import Logs from './Logs'
import Dashboard from './Dashboard'
import FileUpload from './FileUpload'
import Companies from './Companies'
import CompanyEdit from './CompanyEdit'
import CompanyBilling from './CompanyBilling'
import BulkClassify from './BulkClassify'
import Models from './Models'
import ModelEdit from './ModelEdit'
import Login from './Login'
import Azure from './Azure'
import Demo from './Demo'
import Charts from './Charts'
import Register from './Register'
import BcmApiKeys from './BcmApiKeys'
import { Search, GearFill, BarChartFill, ArrowRight, HouseDoorFill, ImageFill, CardList, Grid3x2, PlusCircle, MinusCircle, X, ZommIn, ZoomOut, ArrowsMove } from 'react-bootstrap-icons';
import axios from "axios";
import $ from 'jquery';
import frm from './formAux.js';
import NotFound from './NotFound';


const getHeight = () => window.innerHeight
|| document.documentElement.clientHeight
|| document.body.clientHeight;

function ge(id){ return document.getElementById(id)};
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function sanitize(s)
{
    s = s.trim();
    s = s.replace(/ +/ig,' ');
    return s;
}


function useCurrentHeight() {
    // save current window height in the state object
    let [height, setHeight] = useState(getHeight());

    // in this case useEffect will execute only once because
    // it does not have any dependencies.
    useEffect(() => {
        const resizeListener = () => {
            // change height from the state object
            setHeight(getHeight())
        };

        // set resize listener
        window.addEventListener('resize', resizeListener);

        // clean up function
        return () => {
            // remove resize listener
            window.removeEventListener('resize', resizeListener);
        }
    }, [])

    return height;
}

function Dataset( prop )
{
    var kidx = 0;
    function datasetClick(ev)
    {
        console.log( 'datasetClick', prop.rec );
        // document.location = '#Images';
        window.scrollTo(0,0)

        window.GlobalVars.params.dataset_name = prop.rec.name;
        window.GlobalVars.params.dataset_id = prop.rec.id;
        setTimeout( window.GlobalVars.update, 1 );
        // window.scrollTo(0,0)
        // setTimeout( function(){ window.GlobalVars.update(true)}, 100 );
    }
    var cname = 'item-thumb item-thumb-dataset';
    var cname = 'data-set-container';
    return (
        <div id={prop.rec._id} className={cname}>
        <div style={{display:'block'}}>
        <img src={prop.rec.image_url} onClick={datasetClick}/><br/>
        </div>
        <div className="data-set">{prop.rec.name} <span>{prop.rec.items} images</span></div>
        </div>
    );
}


function FoundDatasets( prop )
{
    console.log( 'FOUND', prop.found )
    if( !prop.found || !prop.found.records ) return loadingDatasets();
    // var message = prop.found ? 'Total Datasets: ' + prop.found.count

    var id = 1234123;
    var variant = prop.found.count > 0 ? 'secondary' : 'danger';
    return (
        <>
        <Alert variant={variant}>
        Total Datasets: {prop.found ? prop.found.count : 0 }
        </Alert>
        {
            prop.found.records.map( r => (
                <Dataset key={r._id} rec={r}/>
            ))
        }
        </>
    )
}

function pageHome( prop, found, setResult )
{
    return (
        <div fluid="md p-0" className="maincontent">
        <Row>
        <Col sm={10} className="maincol">
        <FoundDatasets found={found}/>
        </Col>
        <Col sm={2} className="rightcol">
        <Alert variant="secondary" className="right-alerts">Filter</Alert>
        <Filters/>
        <Alert variant="secondary" className="right-alerts">Labels</Alert>
        <Labels/>
        </Col>
        </Row>
        </div>
    );
}


function loadingItems()
{
    return (
        <Alert variant="secondary">
        <Spinner animation="border" variant="secondary"  size="sm" role="status">
        <span className="sr-only">Loading...</span>
        </Spinner>
          <span className="ml-2">Searching</span>
        </Alert>
    );
}

function loadingDatasets()
{
    return (
        <Alert variant="secondary">
        <Spinner animation="border" variant="secondary"  size="sm" role="status">
        <span className="sr-only">Loading...</span>
        </Spinner>
          <span className="ml-2">Searching</span>
        </Alert>
    );
}

function MyPaginator( prop )
{
    window.__prop = prop;
    var found = prop.found;
    var size = window.GlobalVars.params.size;
    var list = [];
    var ini = Math.floor(found.start/size);
    var len = Math.ceil(found.count/size);
    console.log( 'PAGINATOR', 'ini', ini, 'len', len, 'found', found );
    list = [ini];
    var pagLin = 9;
    for( var i = 1 ; i < pagLin && list.length < pagLin ; i++ )
    {
        if( ini-i >= 0 ) list.unshift( ini-i );
        if( ini+i < len && list.length < pagLin ) list.push( ini+i );
    }
    function pagClick( ev )
    {
        var el = ev.target;
        if( el.tagName != 'A' ) el = el.parentNode;
        var idx = el.getAttribute('idx');
        console.log( 'pagClick', el, idx );
        window.GlobalVars.params.start = idx*size;
        window.GlobalVars.searchDone = false;
        window.scrollTo(0,0)
        window.GlobalVars.search();
    }

    var prev = ini > 0 ? ini-1 : 0;
    var next = ini < len-1 ? ini+1 : len-1;
    var last = len-1;
    //{"count":998,"start":0,"size":32,"
    var kidx = 0;
    if( list.length < 2 ) return ('');
    return (
        <div className="mypaginator">
        <Pagination>
          <span className="pagpage">Page {ini+1} of {len}</span>
          <Pagination.First key={kidx++} idx={0} onClick={pagClick}/>
          <Pagination.Prev key={kidx++} idx={prev} onClick={pagClick}/>
          {
              list.map( l => (
                  <Pagination.Item className={l===ini?'active':''} key={kidx++} idx={l} onClick={pagClick}>{l+1}</Pagination.Item>
              ))
          }
          <Pagination.Next key={kidx++} idx={next} onClick={pagClick}/>
          <Pagination.Last key={kidx++} idx={last} onClick={pagClick}/>
        </Pagination>
        </div>
    );
}

function AspectImage( prop )
{
    // console.log( 'aspect', prop );
    var aspect = prop.aspect*100;
    var src = prop.src;
    var onClick = prop.onClick;
    var zoom = prop.zoom;
    if( !zoom ) zoom = 1;
    var pzoom = zoom*100+'%';
    var panX = prop.panX || 0;
    var panY = prop.panY || 0;
    panX += 'px';
    panY += 'px';
    // console.log( 'PAN', panX, panY );

    return (
        <div className="aspect-container" onClick={onClick}>
            <img className="aspect" width="100" height={aspect}/>
            <div className="aspect-image"><img id={'img_'+prop.id} src={src} style={{width:pzoom, height:pzoom, marginLeft:panX, marginTop:panY}}/></div>
        </div>
    );
}


function ExportDataset(prop)
{
    var vis = window.GlobalVars.page == 'Selected' && prop.found && prop.found.count ? 'block' : 'none';
    var format = 'coco';
    function exp(ev)
    {
        var pdata = mkPostData();
        pdata.export = format;
        var cmd = 'find_items';
        window.post(cmd, pdata, res => {
            console.log( 'EXPORT', res.data );
            function download(dataurl, filename) {
                var a = document.createElement("a");
                a.href = dataurl;
                a.setAttribute("download", filename);
                a.click();
            }

            download("data:text/json,"+JSON.stringify(res.data,null,"\t"), "COCO.json");
        });
    }

    function model(ev)
    {
        var pdata = mkPostData();
        pdata.model = 'YoloV3';
        var cmd = 'find_items';
        window.post(cmd, pdata, res => {
            var data = res.data;
            console.log( 'MODEL', JSON.stringify(data), data.running[0] == data.running[1] );
            if(data && data.running && data.running[0] && data.running[0] == data.running[1] )
            {
                alert( 'MODEL Run finished' );
                window.clearCache()
                setTimeout( function(){document.location.reload()}, 100 );
            }
            else {
                alert( 'MODEL Already Running ('+Math.floor(100*data.running[0]/data.running[1])+'%)' );
            }
        });

    }


    return (
        <div style={{display:vis}}>
        <Button variant="primary" type="submit" className="mt-2" onClick={exp}>Export Selected Images (COCO)</Button>
        <Button variant="primary" type="submit" className="ml-4 mt-2" onClick={model}>Run Model YoloV3</Button>

        </div>
    )
}


function SelAll(prop)
{
    const [smShow, setSmShow] = useState(false);
    function getIds( callback )
    {
        var db = window.dataBuffer;
        var dbCheck = false;
        if( db && db.records.length == db.count )
        {
            dbCheck = true;
            for( var i = 0 ; i < db.records.length ; i++ )
                if( !db.records[i] )
                {
                    dbCheck = false;
                    break;
                }
        }
        if( dbCheck )
        {
            var recs = [];
            for( var i = 0 ; i < db.records.length ; i++ )
                recs.push( db.records[i]._id );
            return callback( recs );
        }
        // var sids = window.GlobalVars.params.selected_ids || ''; if( !sids && window.GlobalVars.page == 'Selected' ) sids = 'nothing';
        // var pdata = {
        //     dataset: window.GlobalVars.params.dataset_id || '',
        //     search: window.GlobalVars.params.search || '',
        //     selected_ids: sids,
        //     start: 0,
        //     size: '',
        //     sel: 1,
        // };
        var pdata = mkPostData();
        pdata.start = 0;
        pdata.size = '';
        pdata.sel = 1;
        setSmShow(true)
        var cmd = 'find_item_ids';
        var cache = window.getCache( pdata );
        if( cache ) return setTimeout( function(){
            result(cache);
        }, 1 );
        window.post(cmd, pdata, res => {
            result(res.data);
        });
        function result(data)
        {
            var recs = [];
            // console.log( 'DATA', data )
            data.records.forEach( d => recs.push(d._id) );
            setSmShow(false);
            callback(recs);
        }
    }
    function sel()
    {
        getIds( recs => {
            recs.forEach( r => window.setSelected( r, 1 ));
            setTimeout( function(){ window.GlobalVars.update(false)}, 100 );
        });
    }

    function del()
    {
        getIds( recs => {
            recs.forEach( r => window.setSelected( r, 0 ));
            setTimeout( function(){ window.GlobalVars.update(false)}, 100 );
        });
    }
    var page = window.GlobalVars.page;
    var link = '#'+page;
    return (
        <>
        <Modal
        size="sm"
        show={smShow}
        backdrop="static"
        onHide={() => setSmShow(false)}
        aria-labelledby="example-modal-sizes-title-sm"
        >

        <Modal.Body>Selecting all Images</Modal.Body>
        </Modal>
        <div className="select-all" style={{display:prop.found && prop.found.count ? 'block':'none'}}>
        <a href={link} onClick={sel}>Select All</a> - <a href={link} onClick={del}>Deselect All</a>
        </div>
        </>
    )
}


var mouseEvents = ['wheel','mousedown','mouseup','mousemove','click'];

function Item( prop )
{
    const [selected, setSelected] = useState(window.GlobalVars.selected[prop.rec._id]);
    var tagsOn = prop.tagsOn;
    // console.log( 'tagsOn', tagsOn );
    // if( window.GlobalVars.params.annotations ) console.log( 'annotate', prop.rec, prop.rec )
    var iWidth = prop.rec.image_size[0].width;
    var iHeight = prop.rec.image_size[0].height;
    var alist = [];
    var kidx = 0;

    var tagsOnOk = Object.keys(tagsOn).length > 0;
    // console.log( 'draw item')
    prop.rec.annotations.forEach( a => {
        var aGroup = a.group || 'Ground Truth';
        if( !window.GlobalVars.params.annotations[aGroup] ) return;
        var oa = {};
        // check if annotation fits filter
        var aok = false;
        if(tagsOnOk) a.indexes.forEach( idx => { if( idx in tagsOn ) aok = true; });
        else aok = true;
        if( !aok ) return;

        // add annotation to the view list
        oa.group = aGroup;
        oa.groupIdx = window.GlobalVars.annotationGroups.indexOf(aGroup);
        oa.class = a.class;
        oa.top = 100*a.top/iHeight;
        oa.left = 100*a.left/iWidth;
        oa.width = 100*a.width/iWidth;
        oa.height = 100*a.height/iHeight;
        alist.push( oa );
    });
    function imgClick(ev)
    {
        if( prop.max == 1 )
        {
            window.GlobalVars.params.viewmode = window.GlobalVars.params.prevmode;
            setTimeout( function(){ window.GlobalVars.update(true)}, 100 );
            return;
        }
        window.GlobalVars.params.viewmode = 2;
        window.GlobalVars.params.detail = prop.rec;
        console.log( 'imgClick', prop.rec );
        window.scrollTo(0,0)
        setTimeout( function(){ window.GlobalVars.update(true)}, 100 );
    }
    function selClick(ev) {
        console.log( ev.target.checked );
        setSelected( ev.target.checked );
        window.setSelected( prop.rec._id, ev.target.checked );
        // window.GlobalVars.selected[prop.rec._id] = {selected:ev.target.checked,rec:prop.rec};
        window.saveSession();
    }

    function getDiv( o )
    {
        while( o && o.id != prop.rec._id ) o = o.parentElement;
        return o;
    }

    function detailVar( id, v )
    {
        // console.log( 'detailVar', id, v );
        if( !v ) return !window.detailVar || !window.detailVar[id] ? null : window.detailVar[id];
        if( !window.detailVar ) window.detailVar = {};
        window.detailVar[id] = v;
        return v;
    }

    function divEvent( ev )
    {
        var border = 4;

        if( ev.target && ev.target.tagName == 'INPUT' ) return true;
        var div = getDiv(ev.target);
        var dVar = detailVar(prop.rec._id);
        if( !dVar ) dVar = {zoom:1,panX:0,panY:0};
        if( dVar.panning ) div = ge(prop.rec._id);
        if( !div ) return;
        var rect = div.getBoundingClientRect();
        var x = ev.pageX-rect.x;
        var y = ev.pageY-rect.y;
        var iw = rect.width;
        var ih = rect.height;
        // console.log( 'divEvent', ev.type, x, y, ev.wheelDelta, rect );
        var px = dVar.panX/dVar.zoom;
        zoom = dVar.zoom;
        panX = dVar.panX;
        panY = dVar.panY;

        function adjust()
        {
            var img = ge('img_'+prop.rec._id);
            var irect2 = img.getBoundingClientRect();

            // fixPan
            if( panX > 0 ) panX = 0;
            if( panY > 0 ) panY = 0;
            if( (irect2.width+panX) < (rect.width-border*2) ) panX = -irect2.width+(rect.width-border*2)
            if( (irect2.height+panY) < (rect.height-border*2) ) panY = -irect2.height+(rect.height-border*2)

            img.style.marginLeft = panX+'px';
            img.style.marginTop = panY+'px';
            dVar.panX = panX;
            dVar.panY = panY;
            detailVar(prop.rec._id,dVar);

            alist.forEach( (a,idx) => {
                var adiv = ge('a_'+idx+'_'+prop.rec._id);
                adiv.style.top = (a.top*zoom)+'%';
                adiv.style.marginTop = panY+'px';
                adiv.style.left = (a.left*zoom)+'%';
                adiv.style.marginLeft = panX+'px';
                adiv.style.width = (a.width*zoom)+'%';
                adiv.style.height = (a.height*zoom)+'%';
            });
        }
        if( ev.type == 'mousedown' )
        {
            dVar.startPanX = dVar.panX;
            dVar.startPanY = dVar.panY;
            dVar.px = ev.pageX;
            dVar.py = ev.pageY;
            dVar.panning = true;
            detailVar(prop.rec._id,dVar);
        }
        if( ev.type == 'mouseup' )
        {
            dVar.panning = false;
            detailVar(prop.rec._id,dVar);
            var dx = ev.pageX-dVar.px;
            var dy = ev.pageY-dVar.py;
            if( Math.sqrt(dx*dx+dy*dy) < 3 ) imgClick();
        }
        if( ev.type == 'mousemove' && dVar.panning )
        {
            var dx = ev.pageX-dVar.px;
            var dy = ev.pageY-dVar.py;
            panX = dVar.startPanX+dx;
            panY = dVar.startPanY+dy;
            adjust();
        }
        if( ev.type == 'wheel' )
        {
            var irect = ge('img_'+prop.rec._id).getBoundingClientRect();
            var ix = (ev.pageX-irect.x)/irect.width;
            var iy = (ev.pageY-irect.y)/irect.height;
            console.log( 'IIIIIIIIIIIIIIMG',ev.pageY, irect.y, irect.height)
            var dz = ev.wheelDelta/240;
            var nzoom = zoom+dz*0.1;
            // nzoom = 2;
            if( nzoom < 1 ) nzoom = 1;
            if( nzoom > 8 ) nzoom = 8;
            zoom = nzoom;
            dVar.zoom = zoom;
            var img = ge('img_'+prop.rec._id);
            window.cimg = img;
            img.style.width = img.style.height = 100*zoom+'%';
            img.style.marginLeft = '0%';
            img.style.marginTop = '0%';
            var irect2 = img.getBoundingClientRect();
            var ix2 = ev.pageX-(irect2.width*ix+irect2.x);
            var iy2 = ev.pageY-(irect2.height*iy+irect2.y);
            console.log('------IMG', ev.pageY, irect2.height ,iy , irect2.y );

            var panX = ix2;
            var panY = iy2;
            adjust();

        }
        ev.preventDefault();

        return false;
    }


    var onClick = imgClick;
    var dVar = detailVar(prop.rec._id);
    if( !dVar || prop.max != 1 ) dVar = {zoom:1,panX:0,panY:0};
    var zoom = dVar.zoom;
    var panX = dVar.panX;
    var panY = dVar.panY;
    var cname = 'item-thumb';
    if( prop.max == 1 )
    {
        mouseEvents.forEach( e => window.clearEvent(e) );
        mouseEvents.forEach( e => {
            window.addEvent(e, divEvent );
        })
        window.onwheel = divEvent;
        onClick = null;
        cname = 'item-thumb item-thumb-max';
        detailVar(prop.rec._id,dVar)
    }

    if( prop.max == 2 ) cname = 'item-thumb item-thumb-next';
    if( prop.detail ) cname = 'item-thumb item-thumb-detail';
    var aspect = prop.rec.image_size[0].height/prop.rec.image_size[0].width;
    // console.log( 'prop.rec2', aspect );
    return (
        <div id={prop.rec._id} className={cname}>
        <AspectImage id={prop.rec._id} aspect={aspect} zoom={zoom} panX={panX} panY={panY} src={prop.rec.url} onClick={onClick}/>
        {
            alist.map( (a,idx) => {
                // console.log( 'annotation', a.top, panY, zoom )
                var st = {
                    top:a.top*zoom+'%',
                    marginTop:panY+'px',
                    left:a.left*zoom+'%',
                    marginLeft:panX+'px',
                    width:a.width*zoom+'%',
                    height:a.height*zoom+'%',
                };
                var cname = 'annotation_'+a.groupIdx;
                return (
                        <div id={'a_'+idx+'_'+prop.rec._id} key={kidx++} className={cname} style={st} onClick={onClick}><div>{a.class}</div></div>
                )
            })
        }
        <input type="checkbox" className="item-select" checked={selected} onChange={selClick}/>
        </div>
    );
    // return (
    //     <div id={prop.rec._id} className={cname}>
    //     <img src={prop.rec.url} onClick={imgClick}/>
    //     {
    //         alist.map( a => {
    //             var st = {top:a.top,left:a.left,width:a.width,height:a.height};
    //             return (
    //                     <div key={kidx++} className="annotation" style={st} onClick={imgClick}><div>{a.class}</div></div>
    //             )
    //         })
    //     }
    //     <input type="checkbox" className="item-select" checked={selected} onChange={selClick}/>
    //     </div>
    // );
}


function scrollToElement( id, prop )
{
    clearTimeout(window.GlobalVars.scrollTid);
    window.GlobalVars.scrollTid = setTimeout( function(){
        var el = document.getElementById(id);
        if( !el ) return;
        // console.log( 'scrollToElement', id, el, getTop(el) );
        var top = el.getBoundingClientRect().top;
        window.scrollBy(0,top-200)
    }, 10 )
}

window.scrollToElement = scrollToElement;


function FoundItems( prop )
{
    var tagsOn = window.GlobalVars.filter;
    if( window.GlobalVars.params.viewmode == 1 ) return FoundItemsGrid( prop );
    if( window.GlobalVars.params.viewmode == 2 ) return FoundItemsDetail( prop );
    console.log( 'FOUND', prop.found )
    mouseEvents.forEach( e => window.clearEvent(e) );
    if( !prop.found || !prop.found.records ) return loadingItems();
    window.GlobalVars.params.prevmode = window.GlobalVars.params.viewmode;

    var recDetail = prop.found.records[detailIdx(prop)];
    if( recDetail ) scrollToElement( recDetail._id, prop );


    function switchType(ev)
    {
        var el = ev.target;
        if( el.tagName != 'svg') el = el.parentNode;
        var mode = el.getAttribute('mode')*1;
        console.log( 'TYPE', mode, mode*1, el.tagName, el )
        window.GlobalVars.params.viewmode = mode;
        setTimeout( function(){ window.GlobalVars.update(true)}, 100 );
        window.saveSession();
    }
    // var message = prop.found ? 'Total Datasets: ' + prop.found.count
    var variant = prop.found && prop.found.count > 0 ? 'secondary' : 'danger';

    var txt = window.GlobalVars.page == 'Selected' ? 'Selected Images' : 'Explore Open Source datasets';
    return (
        <>
        <Alert variant={variant}>
        {txt}
        <span className="search-result">
        Total Images: {prop.found ? prop.found.count : 0 }
        <CardList alt="List Mode" className="grid-flip" mode={1} onClick={switchType}/>
        <ImageFill alt="Detail Mode" className="grid-flip" mode={2} onClick={switchType}/>
        </span>
        </Alert>
        <div className="sel-bar">
        <SelAll found={prop.found}/>
        <MyPaginator found={prop.found}/>
        </div>
        {
            prop.found.records.map( r => (
                <Item key={r._id} detail={r._id == recDetail._id} rec={r} tagsOn={tagsOn}/>
            ))
        }
        <MyPaginator found={prop.found}/>
        <ExportDataset found={prop.found}/>
        </>
    )
}

function detailIdx(prop)
{
    var det = window.GlobalVars.params.detail;
    if( !det ) return 0;
    if( !prop.found || !prop.found.records || !prop.found.records.length ) return 0;
    for( var i = 0 ; i < prop.found.records.length ; i++ )
    {
        // console.log( 'checkDetail', i, prop.found.records[i]._id, det.id )
        if( prop.found.records[i]._id == det._id ) return i;
    }
    return 0;
}


function goSearch( s )
{
}

window.go = goSearch;


function Tagcloud(prop)
{
    var tags = Object.keys(prop.rec.keys);
    console.log( 'TAGS', tags, prop.tagsOn );
    var kid = Math.random();
    return (
        <>
        {
            tags.map( t => (
                <Tag key={kid++} rec={t} tagsOn={prop.tagsOn} extraTags={prop.extraTags} setExtratags={prop.setExtratags}/>
            ))
        }
        </>
    )
}


function Tag(prop)
{
    const [selected, setSelected] = useState(prop.rec in prop.tagsOn);
    function selClick(ev)
    {
        console.log( 'selClick', ev.target.checked )
        var sel = !selected;
        var newTags = window.clone( prop.extraTags )
        newTags[prop.rec] = sel;
        setSelected( sel )
        prop.setExtratags(newTags);
    }
    return (
        <div className="detail-label"><input type="checkbox" onChange={selClick} className="item-select-grid" checked={selected} /><span>{prop.rec}</span></div>
    );
}

function FoundItemsDetail( prop )
{
    const [detail, setDetail] = useState(detailIdx(prop));
    const [extraTags, setExtratags] = useState({});
    var tagsOn = window.clone(window.GlobalVars.filter);
    for( var e in extraTags )
    {
        if( extraTags[e] ) tagsOn[e] = 1;
        else delete tagsOn[e];
    }
    // const [tagsOn, setTags] = useState(window.GlobalVars.filter);
    // const [tagsOn, setTags] = useState(window.clone(window.GlobalVars.filter));
    // if( window.diffObj( tagsOn, window.GlobalVars.filter) )
    //     return setTags(window.clone(window.GlobalVars.filter));

    console.log( 'tagsOn Found', tagsOn, window.GlobalVars.filter, tagsOn === window.GlobalVars.filter )

    console.log( 'FOUND', prop.found )
    if( !prop.found || !prop.found.records ) return loadingItems();

    var start = prop.found.start;
    var size = window.GlobalVars.params.size;
    var count = prop.found.count;

    // console.log( 'detailIdx=', detailIdx(prop), detail )
    if( detail != detailIdx(prop) ) setDetail( detailIdx(prop) )

    function switchType(ev)
    {
        var el = ev.target;
        if( el.tagName != 'svg') el = el.parentNode;
        var mode = el.getAttribute('mode')*1;
        console.log( 'TYPE', mode, mode*1, el.tagName, el )
        window.GlobalVars.params.viewmode = mode;
        setTimeout( function(){ window.GlobalVars.update(true)}, 100 );
        window.saveSession()
    }

    // function goSearch( s )
    // {
    //     window.GlobalVars.params.start = s;
    //     window.GlobalVars.searchDone = false;
    //     window.scrollTo(0,0)
    //     window.GlobalVars.search();
    // }
    function goDetail( d )
    {
        if( d < 0 || d >= count ) return;
        if( d-start < 0 )
        {
            window.GlobalVars.params.detailTarget = size-1;
            return goSearch( start-size );
        }
        else if( d-start >= size )
        {
            window.GlobalVars.params.detailTarget = 0;
            return goSearch( start+size );
        }
        setDetail(d-start);
        window.GlobalVars.params.detail = prop.found.records[d-start];
        window.saveSession();
    }

    function pagClick( ev )
    {
        var el = ev.target;
        if( el.tagName != 'A' ) el = el.parentNode;
        var idx = el.getAttribute('idx')*1;
        console.log( 'pagClick', el, idx );
        goDetail( imgIdx+(idx?1:-1) );
        // window.GlobalVars.params.start = idx*size;
        // window.GlobalVars.searchDone = false;
        // window.scrollTo(0,0)
        // window.GlobalVars.search();
    }

    var nav = [];
    for( var i = 0 ; i < 3 ; i++ )
    {
        var idx = i+detail+1;
        if( idx >= prop.found.records.length )
        {
            // nav.push(1);
            break;
        }
        nav.push(prop.found.records[idx]);
    }

    if( detailIdx(prop) != detail ) return setDetail( detailIdx(prop) )
    var recDetail = prop.found.records[detailIdx(prop)];

    // var message = prop.found ? 'Total Datasets: ' + prop.found.count
    var variant = prop.found && prop.found.count > 0 ? 'secondary' : 'danger';
    var kidx = 0;
    var imgIdx = prop.found.start+detail;
    var tot = prop.found.count;
    if( !prop.found.count ) return (
        <>
        <Alert variant={variant}>
        Explore Open Source datasets
        <span className="search-result">
        Total Images: {prop.found ? prop.found.count : 0 }
        <Grid3x2 alt="List Mode" className="grid-flip" mode={0} onClick={switchType}/>
        <CardList alt="List Mode" className="grid-flip" mode={1} onClick={switchType}/>
        </span>
        </Alert>
        </>
    );
    return (
        <>
        <Alert variant={variant}>
        Explore Open Source datasets
        <span className="search-result">
        Total Images: {prop.found ? prop.found.count : 0 }
        <Grid3x2 alt="List Mode" className="grid-flip" mode={0} onClick={switchType}/>
        <CardList alt="List Mode" className="grid-flip" mode={1} onClick={switchType}/>
        </span>
        </Alert>
        <div fluid="md p-0" className="maincontent">
        <Row>
        <Col sm={3} className="img-details">

        <div className="pag-detail">
        <Pagination>
          <Pagination.Item key={kidx++} idx={0} onClick={pagClick}>Previous</Pagination.Item>
          <span className="pos">{imgIdx+1} / {tot}</span>
          <Pagination.Item key={kidx++} idx={1} onClick={pagClick}>Next</Pagination.Item>
        </Pagination>
        </div>

        <Table>
        <tbody>
        <tr><td>Id:</td><td>{recDetail._id}</td></tr>
        <tr><td>Dataset:</td><td>{recDetail.data_set_name}</td></tr>
        <tr><td>Original URL:</td><td>{recDetail.s3_path}</td></tr>
        <tr><td>Annotations</td><td><Tagcloud rec={recDetail} tagsOn={tagsOn} extraTags={extraTags} setExtratags={setExtratags}/></td></tr>
        <tr><td>Image Labels</td><td><ImgLabels rec={recDetail} detailIdx={detail}/></td></tr>
        </tbody>
        </Table>

        </Col>
        <Col sm={9}>
        <Item key={recDetail._id} max={1} rec={recDetail} tagsOn={tagsOn}/><br/>
        {
            nav.map( r => (
                <Item key={r._id} max={2} rec={r} tagsOn={tagsOn}/>
            ))
        }
        </Col>
        </Row>
        </div>
        </>
    )
}



function ItemGrid( prop )
{
    const [selected, setSelected] = useState(window.GlobalVars.selected[prop.rec._id]);
    // if( window.GlobalVars.params.annotations ) console.log( 'annotate', prop.rec, prop.rec )
    var iWidth = prop.rec.image_size[0].width;
    var iHeight = prop.rec.image_size[0].height;
    var alist = [];
    var kidx = 0;
    if( window.GlobalVars.params.annotations ) prop.rec.annotations.forEach( a => {
        var oa = {};
        oa.class = a.class;
        oa.top = 100*a.top/iHeight+'%';
        oa.left = 100*a.left/iWidth+'%';
        oa.width = 100*a.width/iWidth+'%';
        oa.height = 100*a.height/iHeight+'%';
        alist.push( oa );
    });
    function imgClick(ev)
    {
        window.GlobalVars.params.viewmode = 2;
        window.GlobalVars.params.detail = prop.rec;
        console.log( 'imgClick', prop.rec );
        window.scrollTo(0,0)
        setTimeout( function(){ window.GlobalVars.update(true)}, 100 );
        window.saveSession();
    }
    function selClick(ev) {
        console.log( ev.target.checked );
        setSelected( ev.target.checked );
        window.setSelected( prop.rec._id, ev.target.checked );
        // window.GlobalVars.selected[prop.rec._id] = {selected:ev.target.checked,rec:prop.rec};
        window.saveSession()
    }
    var cname ="item-thumb item-thumb-mini";
    if( prop.detail ) cname += ' item-thumb-detail';

    var aspect = prop.rec.image_size[0].height/prop.rec.image_size[0].width;

    return (
        <tr>
        <td>
            <input type="checkbox" className="item-select-grid" checked={selected} onChange={selClick}/>
        </td>
        <td>
            <div id={prop.rec._id} className={cname} onClick={imgClick}>
            <AspectImage aspect={aspect} src={prop.rec.url}/>
            </div>
        </td>
        <td>{prop.rec.data_set_name}</td>
        <td>{alist.length}</td>
        <td>{prop.rec.s3_path}</td>
        </tr>
    );
    // return (
    //     <div key={prop.rec._id} className="textrec">{JSON.stringify(prop.rec)}</div>
    // );
}

function FoundItemsGrid( prop )
{
    console.log( 'FOUND', prop.found )
    if( !prop.found || !prop.found.records ) return loadingItems();
    var recDetail = prop.found.records[detailIdx(prop)];
    if( recDetail ) scrollToElement( recDetail._id, prop );
    mouseEvents.forEach( e => window.clearEvent(e) );

    window.GlobalVars.params.prevmode = window.GlobalVars.params.viewmode;
    function switchType(ev)
    {
        var el = ev.target;
        if( el.tagName != 'svg') el = el.parentNode;
        var mode = el.getAttribute('mode')*1;
        console.log( 'TYPE', mode, mode*1, el.tagName, el )
        window.GlobalVars.params.viewmode = mode;
        setTimeout( function(){ window.GlobalVars.update(true)}, 100 );
        window.saveSession();
    }
    // var message = prop.found ? 'Total Datasets: ' + prop.found.count

    var variant = prop.found && prop.found.count > 0 ? 'secondary' : 'danger';
    return (
        <>
        <Alert variant={variant}>
        Explore Open Source datasets
        <span className="search-result">
        Total Images: {prop.found ? prop.found.count : 0 }
        <Grid3x2 alt="Grid Mode" className="grid-flip" mode={0} onClick={switchType}/>
        <ImageFill alt="Detail" className="grid-flip" mode={2} onClick={switchType}/>
        </span>
        </Alert>
        <div className="sel-bar">
        <SelAll found={prop.found}/>
        <MyPaginator found={prop.found}/>
        </div>
        <Table bordered hover size="sm" className="table-grid">
            <thead>
                <tr>
                <th>&nbsp;</th>
                <th>Image</th>
                <th>Dataset</th>
                <th>Annotations</th>
                <th>Original S3 URL</th>
                </tr>
            </thead>
            <tbody>
        {
            prop.found.records.map( r => (
                <ItemGrid key={r._id} detail={r._id == recDetail._id} rec={r}/>
            ))
        }
            </tbody>
        </Table>
        <MyPaginator found={prop.found}/>
        <ExportDataset found={prop.found}/>
        </>
    )
}


function pageItems( prop, found, setResult )
{
    return (
        <div fluid="md p-0" className="maincontent">
        <Row>
        <Col sm={10} className="maincol">
        <FoundItems found={found}/>
        </Col>
        <Col sm={2} className="rightcol">
        <Alert variant="secondary">Filter</Alert>
        </Col>
        </Row>
        </div>
    );
}

function pageNotFound( prop )
{
    return (
        <Container fluid="md">
        <Alert variant="danger">
          Page Not Found!
        </Alert>
        </Container>
    );
}

function saveBuffer(data)
{
    if( !window.dataBuffer )
        window.dataBuffer = {count:0,records:[]}
    var dbuff = window.dataBuffer;
    console.log( 'BUFFER', dbuff )
    dbuff.count = data.count;
    for( var i = 0 ; i < data.size ; i++ )
        dbuff.records[i+data.start] = data.records[i];
}

function hasBuffer( pdata )
{
    return (window.dataBuffer && window.dataBuffer.records[pdata.start]);
}

function getBuffer( pdata )
{
    var dbuff = window.dataBuffer;
    var start = pdata.pageStart;
    var ret = {count:dbuff.count,records:[],start:start,size:0};
    var idx = start;
    for( var i = 0 ; i < pdata.pageSize && idx < ret.count; i++, idx++ )
        ret.records.push(dbuff.records[idx]);
    ret.size = ret.records.length;
    console.log( 'getBuffer', ret )
    return ret;
}

function getSelected(pdata)
{
    var sel = window.GlobalVars.selected || {};
    var keys = Object.keys(sel);
    var recs = [];
    keys.forEach( k => {
        if( sel[k] ) recs.push( k )
    } );
    return recs;
}

function getFullDataset(prop, callback )
{
    if( !window.GlobalVars.userPriv || window.GlobalVars.fullDatasetLoading ) return;
    window.GlobalVars.fullDatasetLoading = true;
    var pdata = {size:1000000};
    function result( data )
    {
        delete window.GlobalVars.fullDatasetLoading;
        window.GlobalVars.fullDataset = data;
        window.getPossibleLabels( window.GlobalVars.fullDataset.records );
        callback();
    }
    var cache = window.getCache('fullDataset');
    if( cache ) return setTimeout( function(){
        result( cache );
    }, 1 );
    window.post('find_datasets', {size:1000000}, res => {
        window.setCache('fullDataset', res.data );
        result(res.data);
        window.saveSession();
    });
}

function mkPostData()
{
    var sids = window.GlobalVars.params.selected_ids || '';
    if( !sids && window.GlobalVars.page == 'Selected' ) sids = 'nothing';
    var agroups = [];
    for( var ag in window.GlobalVars.params.annotations )
        if( window.GlobalVars.params.annotations[ag] )
            agroups.push(ag);
    var pdata = {
        dataset: window.GlobalVars.params.dataset_id || '',
        search: window.GlobalVars.params.search || '',
        selected_ids: sids,
        annotation_groups: agroups.join(','),
        size: window.GlobalVars.params.bufferSize || '',
        pageSize: window.GlobalVars.params.size || '',
    };
    if( window.GlobalVars.page == 'Selected' ) delete pdata.search;
    return pdata;
}

var currentPage = null;
function Content(prop) {
    const [found, setResult] = useState(null);

    // function search(reset)
    // {
    //     if( !window.GlobalVars.effectDone ) return;
    //     if( window.GlobalVars.searchDone ) return;
    //     currentPage = window.getPage();
    //     var page = window.GlobalVars.page;
    //     if( !window.GlobalVars.fullDataset )
    //     {
    //         return getFullDataset(prop,function(){
    //             search(reset);
    //         });
    //     }
    //     if( reset )
    //     {
    //         window.dataBuffer = null;
    //         window.GlobalVars.params.start = 0;

    //     }
    //     if( window.GlobalVars.page == 'Datasets' )
    //     {
    //         delete window.GlobalVars.params.dataset_id;
    //         delete window.GlobalVars.params.dataset_name;
    //     }
    //     window.getPossibleLabels( window.GlobalVars.fullDataset.records );
    //     setResult(null)
    //     window.GlobalVars.params.search = searchFromFilter();
    //     window.GlobalVars.searchDone = true;
    //     console.log( 'SEARCH')
    //     if( page != 'Datasets' && page != 'Images' && page != 'Selected' ) return;
    //     var pageStart = window.GlobalVars.params.start || 0;
    //     var start = Math.floor(pageStart/window.GlobalVars.params.bufferSize)*window.GlobalVars.params.bufferSize;
    //     if( page == 'Selected' )
    //     {
    //         if( !window.GlobalVars.params.selected_ids )
    //             window.GlobalVars.params.selected_ids = getSelected().join(',');
    //     }
    //     else window.GlobalVars.params.selected_ids = null;

    //     // var pdata = {
    //     //     dataset: window.GlobalVars.params.dataset_id || '',
    //     //     search: window.GlobalVars.params.search || '',
    //     //     selected_ids: sids,
    //     //     size: window.GlobalVars.params.bufferSize || '',
    //     //     pageSize: window.GlobalVars.params.size || '',
    //     //     start: start,
    //     //     pageStart: pageStart,
    //     // };
    //     var pdata = mkPostData();
    //     pdata.start = start;
    //     pdata.pageStart = pageStart;

    //     function setDetail(data)
    //     {
    //         if( window.GlobalVars.params.detailTarget !== null )
    //         {
    //             window.GlobalVars.params.detail = data.records[window.GlobalVars.params.detailTarget];
    //             window.GlobalVars.params.detailTarget = null;
    //         }
    //     }
    //     function result(data)
    //     {
    //         setDetail(data);
    //         setResult(data);
    //         console.log( 'RESULT', data )
    //     }
    //     var cmd = window.GlobalVars.page == 'Datasets' ? 'find_datasets' : 'find_items';
    //     pdata.cmd = cmd;
    //     var psearch = pdata.dataset+pdata.search;
    //     if( psearch != window.GlobalVars.params.lastsearch )
    //     {
    //         window.GlobalVars.params.detail = window.GlobalVars.params.detailTarget = null;
    //     }
    //     window.GlobalVars.params.lastsearch = psearch;
    //     window.saveSession();



    //     if( hasBuffer( pdata ) )
    //     {
    //         setTimeout( function(){
    //             result( getBuffer( pdata ) );
    //         }, 1)
    //         return;
    //     }
    //     var cache = window.getCache( pdata );
    //     if( cache ) return setTimeout( function(){
    //         saveBuffer(cache);
    //         result(getBuffer(pdata));
    //     }, 1 );
    //     window.post(cmd, pdata, res => {
    //         window.setCache( pdata, res.data );
    //         if( res.data.records && res.data.records.length )
    //         { // uncache incase urls are void
    //             let r = res.data.records[0];
    //             if( r.url === "" || r.image_url === "" )
    //                 window.delCache( pdata );
    //         }
    //         saveBuffer(res.data);
    //         result(getBuffer(pdata));
    //     });
    //     //
    //     // var loc = document.location;
    //     // var url = loc.protocol + '//' + loc.hostname + ':8088/'+cmd;
    //     // console.log( 'POSTDATA', pdata )
    //     // axios.post( url, pdata ).then( res => {
    //     //     window.setCache( pdata, res.data );
    //     //     setResult(res.data);
    //     // })
    // }
    window.GlobalVars.setResult = setResult;
    // window.GlobalVars.search = search;
    useEffect( function(){
        currentPage = window.getPage();
        $(window).on('popstate', function(event) {
            // document.location.reload();
            setTimeout( function(){
                if( window.getPage() != currentPage && window.pageHash.indexOf('#code') != 0 )
                {
                    document.location.reload();
                }
            }, 100 )
        } );
        window.GlobalVars.effectDone = true;
        // search(found==null)
    },[]);
    // search(found==null);

    if (window.GlobalVars.page == 'Demo')
        return (
            <Demo />
        )

        if (window.GlobalVars.page == 'Charts')
        return (
            <Charts />
        )

    if (window.GlobalVars.page == 'Register')
        return (
            <Register />
        )

    if (window.GlobalVars.page == 'Assessment API key')
        return (
            <BcmApiKeys />
        )

    // console.log( 'LOGINCHECK', (!window.GlobalVars.user || !window.GlobalVars.sessionId || Date.now() > window.GlobalVars.expireTime), !(window.GlobalVars.page == 'Login') );
    // console.log( 'LOGINCHECK2', !window.GlobalVars.user, !window.GlobalVars.sessionId, Date.now() > window.GlobalVars.expireTime, !(window.GlobalVars.page == 'Login') );

    // console.log( 'currentPAGE', window.GlobalVars.page )
    var pageId = (window.GlobalVars.pageMenu && window.GlobalVars.pageMenu.id) || null;

    if( !window.GlobalVars.page ) window.GlobalVars.page = '';
    if( (!window.GlobalVars.user || !window.GlobalVars.sessionId || Date.now() > window.GlobalVars.expireTime ) && !(window.GlobalVars.page.match(/(login|demo)/i)) )
    {
        setTimeout( function(){
            // window.goPage('login')
            window.login();
        }, 200 )
        return null;
    }


    window.setNavActive(pageId);
    if( pageId == 'logout' || pageId == 'Logout' || pageId === null )
    {
        window.endSession();
        // return null;

        clearTimeout( window.logoutTid );
        window.logoutTid = setTimeout( function(){
            // window.goPage('login')
            window.login();
            // document.location = '#Login'
            // alert(1)
        }, 200 );
        window.GlobalVars = {};
        return null;

    }
    // alert( window.GlobalVars.page );

    if( window.GlobalVars.userRedefinePassword ) return (
        <AccountSettings/>
    )
    // if( window.GlobalVars.page == 'Datasets' ) return pageHome( prop, found, setResult );
    // else if( window.GlobalVars.page == 'Images' ) return pageItems( prop, found, setResult );
    // else if( window.GlobalVars.page == 'Images' || window.GlobalVars.page == 'Selected' )
    // {
    //     var c1 = 10;
    //     var c2 = 2;
    //     var showc2 = 'block';
    //     if( pageId == 'selected' ){ c1 += 1; showc2 = 'none' }
    //     return (
    //         <div className="maincontent" fluid="md p-0">
    //         <Row>
    //         <Col sm={c1} className="maincol">
    //         <FoundItems found={found}/>
    //         </Col>
    //         <Col sm={c2} className="rightcol" style={{display:showc2}}>
    //         <Alert variant="secondary" className="right-alerts">Filter</Alert>
    //         <Filters/>
    //         <Alert variant="secondary" className="right-alerts">Labels</Alert>
    //         <Labels/>
    //         </Col>
    //         </Row>
    //         </div>
    //     )
    // }
    var urlp = document.location.href
    var letvalidateChecker=checkUrl(urlp);

function checkUrl(url) {
  try {
    const parsed = new URL(url);

    //  Case 1: params query
    if (parsed.search && parsed.search.startsWith("?params=")) {
      console.log(" Correct: valid params URL ->", url);
      return true;
    }

    // Must have a hash for validation
    if (!parsed.hash) {
      console.log(" Wrong: no hash (#) present ->", url);
      return false;
    }

    //  Case 2: root path with # (like /#Projects)
    if (parsed.pathname === "/" || parsed.pathname === "") {
      console.log(" Correct: root path with hash ->", url);
      return true;
    }

    //  Everything else is wrong (any junk between / and #)
    console.log(" Wrong: invalid path before # ->", parsed.pathname, url);
    return false;

  } catch (err) {
    console.log(" Invalid URL:", err.message);
    return false;
  }
}


console.log("letvalidateChecker",letvalidateChecker);


    if(!letvalidateChecker){
        return (
            <NotFound />
        );
    }
    else if (pageId == 'datasets') {
        return (
            <DatasetBrowse/>
        )
    }    
    else if (pageId == 'datasetSetup') {
        return (
            <DatasetSetup/>
        )
    }    
    else if (pageId == 'datasetTeam') {
        return (
            <DatasetWorkers/>
        )
    }   
    else if (pageId == 'datasetExports') {
        return (
            <DatasetExports/>
        )
    }
    else if (pageId == 'datasetRecipes') {
        return (
            <DatasetRecipes/>
        )
    }
    else if (pageId == 'datasetRecipeView') {
        return (
            <datasetRecipeView/>
        )
    }
    else if (pageId == 'datasetChatBot') {
        return (
            <DatasetChatBot/>
        )
    }
    else if (pageId == 'datasetModelRuns') {
        return (
            <DatasetModelRuns/>
        )
    }
    else if (pageId == 'projectExports') {
        return (
            <ProjectExports/>
        )
    }
    else if (pageId == 'datasetItems') {
        return (
            <DatasetItems/>
        )
    }
    else if (pageId == 'datasetAdvanced') {
        return (
            <DatasetAdvanced/>
        )
    }
    else if (pageId == 'datasetUpload') {
        return (
            <DatasetUpload/>
        )
    }
    else if (pageId == 'accountSettings') {
        return (
            <AccountSettings />
        )
    }
    else if( pageId == 'config' ) return (
        <Config/>
    )
    else if( pageId == 'configDatasets' ) return (
        <LoadDataset/>
    )
    else if( pageId == 'nlpAnnotations' ) return (
        <NlpViewer/>
    )
    else if( pageId == 'bulkAnnotations' ) return (
        <BulkClassify/>
    )
    else if( pageId == 'transcription' ) return (
        <ViewerTranscription/>
    )
     else if( pageId == 'transcription2' ) return (
        <ViewerTranscription2/>
    )
     else if( pageId == 'transcription3' ) return (
        <ViewerTranscription3/>
    )
    else if( pageId == 'poseestimation' ) return (
        <ViewerBBox/>
    )
    else if( pageId == 'segmentation' ) return (
        <ViewerBBox/>
    )
    else if( pageId == 'keypoint' ) return (
        <ViewerBBox/>
    )
    else if( pageId == 'nlpImport' || pageId == 'nlpImport1' || pageId == 'nlpImport2' || pageId == 'nlpImport3' ) return (
        <NlpSetup/>
    )
    else if( pageId == 'nlpWorkers' ) return (
        <NlpWorkers/>
    )
    else if( pageId == 'nlpJobs' )
    {
        // window.GlobalVars.PDFRole = 'nlp_an';
        window.saveSession();
        return (
            <NlpJobs/>
        )
    }
    else if( pageId == 'nlpProjectBrowse' ) return (
        <NlpProjectBrowse/>
    )
    else if( pageId == 'nlpBrowse' ) return (
        <NlpBrowse/>
    )
    else if( pageId == 'test' ) return (
        <Test/>
    )
    else if( pageId == 'users' ) return (
        <Users/>
    )
    else if( pageId == 'userRole' ) return (
        <UserRole/>
    )
    else if( pageId == 'userSetup' ) return (
        <UserSetup/>
    )
    else if( pageId == 'dashboard' ) return (
        <Dashboard/>
    )
    else if( pageId == 'logs' ) return (
        <Logs/>
    )
    else if( pageId == 'fileupload' ) return (
        <FileUpload/>
    )
    else if( pageId == 'companies' ) return (
        <Companies/>
    )
    else if( pageId == 'companyedit' ) return (
        <CompanyEdit/>
    )
    else if( pageId == 'companybilling' ) return (
        <CompanyBilling/>
    )
    else if( pageId == 'models' ) return (
        <Models/>
    )
    else if( pageId == 'modeledit' ) return (
        <ModelEdit/>
    )
    else if( pageId == 'login' ) return (
        <Login/>
    )
    else if( pageId == 'azure' ) return (
        <Azure/>
    )
    else return pageNotFound( prop );
}

function searchFromFilter()
{
    var filter = window.GlobalVars.filter;
    var fkeys = Object.keys(filter);
    var slist = [];
    fkeys.forEach( k => {
        slist.push( filter[k] > 0 ? k : '-'+k );
    });
    return slist.join(' ');
}

function Filters(prop)
{
    let [search, setSearch] = useState(searchFromFilter());
    let [redraw, setFilter] = useState('');
    window.GlobalVars.setFilter = setSearch;
    // if( search != searchFromFilter() ) return setSearch();
    var filter = window.GlobalVars.filter;
    var fkeys = Object.keys(filter);

    console.log( 'FILTERSEARCH', search )
    var sfunc = window.GlobalVars.search;
    var params = window.GlobalVars.params;
    var psearch = params.dataset+params.search;
    if( psearch != window.GlobalVars.params.lastsearch )
    {
        // window.GlobalVars.params.search = search;
        // window.GlobalVars.searchDone = false;
        // sfunc();
        // window.GlovalVars.search();
    }

    var dataset = window.GlobalVars.params.dataset_name || '';
    var dataset_visible = dataset ? 'block' : 'none'
    function delDataset()
    {
        delete window.GlobalVars.params.dataset_id;
        delete window.GlobalVars.params.dataset_name;
        goSearch(0)
    }

    if( !fkeys.length && !dataset ) return (
        <div className="filter-list">
        <center><span>(no filter)</span></center>
        </div>
    );
    var flist = [];
    fkeys.forEach( k => {
        flist.push( {name:k,val:filter[k]});
    })



    return (
        <div className="filter-list">
        <div className="filter-item" onClick={delDataset} style={{display:dataset_visible}}>
        <X/>Dataset:<br/> {dataset}
        </div>
        {
            flist.map( f => (
                <Filter redraw={redraw} rec={f}/>
            ))
        }
        </div>
    );
}


function Filter(prop)
{
    function delFilter()
    {
        delete window.GlobalVars.filter[prop.rec.name];
        window.GlobalVars.setFilter(searchFromFilter())
        window.GlobalVars.setLabels(Math.random())
        goSearch(0)

    }
    return (
            <div className="filter-item" onClick={delFilter}>
            {prop.rec.name}<X/>
            </div>
    );
}




function ImgLabels(prop)
{
    if( !prop.rec.labels ) prop.rec.labels = [];
    let [labels, setLabels] = useState(clone(prop.rec.labels));
    let [nlabel, setnLabel] = useState('');

    var admVisible = window.GlobalVars.userPriv.admin ? 'block' : 'none';

    if( prop.rec.labels.toString() != labels.toString() )
    {
        setLabels(clone(prop.rec.labels));
    }
    console.log( 'LABELS', labels, prop.detailIdx, prop.rec.labels )
    labels = labels.filter( (a) => a > '' );
    if( !labels.length ) return (
        <div className="img-label-list">
        <center><span>(no labels) {labels.join(',')}</span></center>
        <Form.Control className="mt-1" id="imglabel" size="sm" type="text"
        value={nlabel}
        onKeyUp={key} onChange={nlabelChange}
        placeholder="Add Label"
        style={{display:admVisible}} />
        </div>
    );
    function delLabel(ev)
    {
        if( !window.GlobalVars.userPriv.admin ) return;
        var o = ev.target;
        while( o && o.tagName != 'DIV' ) o = o.parentElement;
        var lab = o.getAttribute('lab');
        var nlabels = clone(labels);
        var idx = nlabels.indexOf(lab);
        if( idx >= 0 ) nlabels.splice(idx,1);
        prop.rec.labels = nlabels;
        setLabels( nlabels );
        updateLabels(nlabels);
    }
    function nlabelChange(ev)
    {
        setnLabel(ev.target.value)
    }

    function updateLabels(nlabels)
    {
        var plabels = nlabels.join('|');
        var pdata = {id:prop.rec._id,labels:plabels};
        var cmd = 'update_img_label';
        window.post(cmd, pdata, res => {
            console.log( 'LABEL UPDATED' );
            window.clearCache();
        });
    }
    function key(ev)
    {
        if( ev.keyCode == 13 )
        {
            var nlab = sanitize(ev.target.value);
            if( labels.indexOf(nlab) == -1 )
            {
                var nlabels = clone(labels);
                nlabels.push(nlab);
                console.log( 'labels', nlabels, prop.rec )
                prop.rec.labels = nlabels;
                setnLabel('');
                setLabels( nlabels );
                updateLabels(nlabels);
            }
        }
    }
    return (
        <div className="img-label-list">
        {
            labels.map( l => (
                <ImgLabel key={"l"+l} lab={l} delLabel={delLabel}/>
            ))
        }
        <Form.Control className="mt-1" id="imglabel" size="sm" type="text"
        value={nlabel}
        onKeyUp={key} onChange={nlabelChange}
        placeholder="Add Label"
        style={{display:admVisible}} />
        </div>
    );
}


function ImgLabel(prop)
{
    var admVisible = window.GlobalVars.userPriv.admin ? 'block' : 'none';

    return (
            <div className="filter-item" lab={prop.lab} onClick={prop.delLabel}>
            {prop.lab}<X style={{display:admVisible}}/>
            </div>
    );
}


function Labels(prop)
{
    let [search, setSearch] = useState('');
    let [redraw, setLabels] = useState('');
    window.GlobalVars.setLabels = setLabels;
    function searchChange(ev)
    {
        console.log( ev.target.value )
        setSearch( ev.target.value.toLowerCase() );
    }
    if( !window.GlobalVars.possibleLabels ) return '';
    var keys = window.GlobalVars.possibleLabels;
    return (
        <>
        <Form.Control id="labelSearch" size="sm" type="text" value={search} onChange={searchChange} placeholder="Search Labels" />
        {
            keys.map( (l,idx) => (
                <Label redraw={redraw} setSearch={setSearch} search={search} rec={l} key={'label'+l+idx}/>
            ))
        }
        </>
    );
}

function Label(prop)
{
    if( prop.search > '' && !(prop.rec.name.match(prop.search)) ) return '';
    if( prop.rec.name in window.GlobalVars.filter ) return '';
    function addLabel(ev)
    {
        window.GlobalVars.filter[prop.rec.name] = 1;
        window.GlobalVars.setFilter(searchFromFilter())
        window.GlobalVars.setLabels(Math.random())
        goSearch(0)
    }
    return (
        <div className="label-item" onClick={addLabel}>
        {prop.rec.name} <span>({prop.rec.count})</span>
        </div>
    )
}

export default Content
